import { Component } from "react"
import { connect } from "react-redux"
import { Modal } from "semantic-ui-react"
import { withTranslation } from "react-i18next"
import Select from "../../elements/Select"
import { Grid } from "semantic-ui-react"
import * as vehicleHelpers from "../../helpers/vehicleHelpers"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons"
import { SUCCESS } from "../../constants/notification"
import CustomNotification from "./CustomNotification"
import MiniLoader from "./MiniLoader"

class VehicleReassignmentModal extends Component {
  state = {
    from_vehicle_id: null,
    to_vehicle_id: null,
    from_vehicle: null,
    to_vehicle: null,
    loading: false
  }

  loadAllVehicles = () => {
    this.props.dispatch({
      type: "VEHICLES_LOAD_SAGA"
    })
  }

  handleClose = () => {
    this.props.onClose()
    this.setState({
      from_vehicle_id: null,
      to_vehicle_id: null,
      from_vehicle: null,
      to_vehicle: null,
      loading: false
    })
  }

  vehicleFromChange = (vehicle_id) => {
    const { vehicles } = this.props
    this.setState({
      from_vehicle_id: vehicle_id,
      from_vehicle: vehicles.find((v) => v.id === vehicle_id)
    })
  }

  vehicleToChange = (vehicle_id) => {
    const { vehicles } = this.props
    this.setState({
      to_vehicle_id: vehicle_id,
      to_vehicle: vehicles.find((v) => v.id === vehicle_id)
    })
  }

  vehicleReassignment = () => {
    const { from_vehicle_id, to_vehicle_id } = this.state
    if (!from_vehicle_id || !to_vehicle_id) {
      CustomNotification("danger", "Error", "Both From Vehicle and To Vehicle are required")
      return
    }
    this.setState({ loading: true })
    this.props.dispatch({
      type: "VEHICLE_REASSIGNMENT_SAGA",
      payload: {
        from_vehicle_id: from_vehicle_id,
        to_vehicle_id: to_vehicle_id
      },
      callback: this.afterReassignment
    })
  }

  afterReassignment = (result) => {
    this.setState({ loading: false })
    if (result === SUCCESS) {
      this.loadAllVehicles()
      this.props.onClose()
      return CustomNotification("success", "Success", "Vehicle details swapped successfully")
    } else return CustomNotification("danger", "Error", "Vehicle details swapped failed")
  }

  render() {
    const { open, t, vehicles } = this.props

    const { from_vehicle_id, to_vehicle_id, from_vehicle, to_vehicle, loading } = this.state

    return (
      <Modal size="small" closeIcon open={open} onClose={this.handleClose}>
        <Modal.Content>
          <Modal.Header className="reassignment_vehicle_modal_header">
            <strong>{t("vehicleReassignmentTitle")}</strong>
          </Modal.Header>
          <Modal.Description>
            <Grid verticalAlign="middle" textAlign="center" columns={3}>
              <Grid.Column width={7}>
                <Select
                  fluid
                  onChange={(e) => this.vehicleFromChange(e.target.value)}
                  options={vehicleHelpers.selectOptions(
                    vehicles.filter((item) => item.fleetcor_enrolled == true)
                  )}
                  placeholder={t("FromVehiclePlaceHolder")}
                  value={from_vehicle_id}
                />
              </Grid.Column>

              <Grid.Column width={1}>
                <FontAwesomeIcon icon={faArrowRightLong} size="lg" style={{ marginTop: "10px" }} />
              </Grid.Column>

              <Grid.Column width={7}>
                <Select
                  fluid
                  onChange={(e) => this.vehicleToChange(e.target.value)}
                  options={vehicleHelpers.selectOptions(
                    vehicles.filter((item) => item.fleetcor_enrolled === false),
                    () => {},
                    {
                      semantic: true
                    }
                  )}
                  placeholder={t("ToVehiclePlaceHolder")}
                  value={to_vehicle_id}
                />
              </Grid.Column>

              <Grid.Column width={8}>
                {from_vehicle && (
                  <Grid padded="horizontally" style={{ justifyContent: "end" }}>
                    <Grid.Column width={16}>
                      <p className="vehicle_field">
                        <span>
                          {" "}
                          {from_vehicle && from_vehicle.year
                            ? `${from_vehicle.year} ${from_vehicle.make} ${from_vehicle.model}`
                            : "-"}{" "}
                        </span>
                      </p>
                      <p className="vehicle_field">
                        {t("cardName")}: <span>{from_vehicle.name_of_vehicle || "-"}</span>
                      </p>
                      <p className="vehicle_field">
                        {t("departmentNumber")}:{" "}
                        <span>{from_vehicle.department_number || "-"}</span>
                      </p>
                    </Grid.Column>
                  </Grid>
                )}
              </Grid.Column>
              <Grid.Column width={8}>
                {to_vehicle && (
                  <Grid padded="horizontally">
                    <Grid.Column width={16}>
                      <p className="vehicle_field">
                        <span>
                          {" "}
                          {to_vehicle && to_vehicle.year
                            ? `${to_vehicle.year} ${to_vehicle.make} ${to_vehicle.model}`
                            : "-"}{" "}
                        </span>
                      </p>
                      <p className="vehicle_field">
                        {t("cardName")}: <span>{to_vehicle.name_of_vehicle || "-"}</span>
                      </p>
                      <p className="vehicle_field">
                        {t("departmentNumber")}: <span>{to_vehicle.department_number || "-"}</span>
                      </p>
                    </Grid.Column>
                  </Grid>
                )}
              </Grid.Column>
            </Grid>

            <p style={{ marginTop: "20px" }}>
              <strong>{t("vehicleReassignmentNoteHeading")}</strong>:{" "}
              {t("vehickeReassignmentNoteContent")}{" "}
            </p>
            <div
              className="connet-to-telematics-btn"
              style={{ width: "50%", margin: "50px auto 0 auto", cursor: "pointer" }}
            >
              <div className="btn-wrapper" onClick={() => this.vehicleReassignment()}>
                <div className="btn-text">{loading ? <MiniLoader /> : "Reassign"}</div>
              </div>
            </div>
          </Modal.Description>
        </Modal.Content>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  vehicles: state.vehicles.vehicles
})

export default connect(mapStateToProps)(withTranslation("vehicle")(VehicleReassignmentModal))
